import useWindowEventListener from "seneca-common/utils/hooks/events/useWindowEventListener";

import {
  showNetworkLostToast,
  showNetworkReconnectToast
} from "features/common/toasts/network-connectivity";

import useShowResetPasswordsToast from "./reset-passwords/useShowResetPasswordsToast";
import useShowSurveyToast from "./surveys/useShowSurveyToast";
import ToastContainer from "./ToastContainer";

export default function ToastProvider() {
  useWindowEventListener("online", showNetworkReconnectToast);
  useWindowEventListener("offline", showNetworkLostToast);
  useShowSurveyToast();
  useShowResetPasswordsToast();

  return <ToastContainer />;
}
